'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAsyncPubSubClient = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAsyncPubSubClient = exports.getAsyncPubSubClient = (0, _getIn2.default)(['pubSubClient']);


//////////////////
// WEBPACK FOOTER
// ./js/pubsub/selectors/getAsyncPubSubClient.js
// module id = 412
// module chunks = 2 3